import React from "react"
import PropTypes from "prop-types"
import SelectButton from '../../form_sections/SelectButton';

class LocationFilter extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      tabSelected: 0
    }

    this.descriptionText = this.descriptionText.bind(this)
    this.selectLocation = this.selectLocation.bind(this)
  }

  descriptionText() {
    if(this.props.locals_only) {
      if(this.props.filter === true) {
        return "Only see matches around your area."
      }
      return "Users outside your area won't be able to contact you."
    }
    if(this.props.filter === true) {
      return "You can see matches around the world."
    }
    return "Users around the world will be able to contact you."

  }

  selectLocation(value) {
    this.props.updateLocation(value)
  }

  buttonText(tab) {
    if(tab === true) {
      return "In my location"
    }
    return "Around the world"
  }

  render() {
    return(
      <div className="filterSection">
        {this.state.needGenderModal && this.needGenderModal()}
        <div style={{display: 'flex', flexDirection: 'column'}}>
          <h4 className="sectionHeader">Location</h4>
          <h4 className="greyText" style={{paddingTop: 10}}>{this.descriptionText()}</h4>
        </div>
        <div style={{display: 'flex', flexDirection: 'column'}}>
          <SelectButton
            selected={this.props.locals_only}
            onClick={() => this.selectLocation(true)}
            buttonText={this.buttonText(true)} />
          <SelectButton
            selected={!this.props.locals_only}
            onClick={() => this.selectLocation(false)}
            buttonText={this.buttonText(false)} />
        </div>
      </div>
    )
  }
}


export default LocationFilter;
